var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSidebarCollapse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 20V4H7C4.79086 4 3 5.79086 3 8V16C3 18.2091 4.79086 20 7 20H11Z",
    fill: "#5096E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 20C4.79086 20 3 18.2091 3 16V8C3 5.79086 4.78732 4 6.99647 4C9.96404 4.00001 14.0003 4.00001 17.0042 4.00001C19.2133 4.00001 21 5.79088 21 8.00002V16C21 18.2091 19.2091 20 17 20C13.6667 20 10.3333 20 7 20Z",
    stroke: "#676D75",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10L14 12L16 14",
    stroke: "#5096E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarCollapse);
export default __webpack_public_path__ + "static/media/sidebar-collapse.94f02c48317488550a54cc288472c9c2.svg";
export { ForwardRef as ReactComponent };